import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * True while an affiliate store profile is mounted (BusinessProfilePage sets
 * body[data-affiliate-profile]). Lets global builder-conversion chrome
 * (SmartTriggers, tool strip, matcher CTAs) suppress itself on shopping pages.
 */
export default function useAffiliateProfileActive() {
  const { pathname } = useLocation();
  const [active, setActive] = useState(
    () => typeof document !== 'undefined' && document.body.hasAttribute('data-affiliate-profile'),
  );
  useEffect(() => {
    const check = () => setActive(document.body.hasAttribute('data-affiliate-profile'));
    check();
    const t = setTimeout(check, 400);
    const obs = new MutationObserver(check);
    obs.observe(document.body, { attributes: true, attributeFilter: ['data-affiliate-profile'] });
    return () => { clearTimeout(t); obs.disconnect(); };
  }, [pathname]);
  return active;
}
